import { useMemo } from "react";
import { useMediaMatch } from "rooks";

const minWidth = (value: string) => `(min-width: ${value})`;
const maxWidth = (value: string) => `(max-width: ${value})`;

export type Breakpoints = ReturnType<typeof useBreakpoints>;

/**
 * Returns each breakpoint, indicating whether each is currently
 * active or not
 */
export const useBreakpoints = () => {
  const _default = useMediaMatch(maxWidth("375px"));
  const xs = useMediaMatch(minWidth("375px"));
  const sm = useMediaMatch(minWidth("640px"));
  const md = useMediaMatch(minWidth("1024px"));
  const lg = useMediaMatch(minWidth("1440px"));

  return useMemo(
    () => ({
      default: _default,
      xs,
      sm,
      md,
      lg,
    }),
    [_default, xs, sm, md, lg]
  );
};
